import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countsByType',
    standalone: false
})
export class CountsByKeyPipe<T> implements PipeTransform {
    transform(tableData: T[], countType: string, key: string = 'status'): number {
        return tableData?.filter((data: T) => data && data[key] === countType)?.length || 0;
    }
}
